export default __webpack_public_path__ + "static/Plain-Medium-441a96fddce3174587be082c0580f5bc.woff";